const faqs = [
  {
    id: 1,
    question: 'Wat is de WOO?',
    answer:
      'De Wet Open Overheid (WOO) is de opvolger van de Wet openbaarheid van bestuur (Wob). De wet regelt het recht op informatie over alles wat de overheid doet.',
    category: 'algemeen',
    order: 1,
  },
  {
    id: 2,
    question: 'Hoe kan ik een WOO-verzoek indienen?',
    answer:
      'U kunt een WOO-verzoek indienen via het contactformulier op deze website of door een brief te sturen naar de gemeente Den Haag.',
    category: 'procedures',
    order: 2,
  },
  {
    id: 3,
    question: 'Wat gebeurt er met mijn WOO-verzoek?',
    answer:
      'Na ontvangst van uw verzoek krijgt u een ontvangstbevestiging. De gemeente heeft vier weken de tijd om te reageren op uw verzoek. Deze termijn kan met maximaal twee weken worden verlengd.',
    category: 'procedures',
    order: 3,
  },
];

export default {
  getAll: () => Promise.resolve(faqs),
  getById: (id) => Promise.resolve(faqs.find((faq) => faq.id === id)),
  getByCategory: (category) =>
    Promise.resolve(faqs.filter((faq) => faq.category === category)),
};
